import { createTheme, rem } from '@mantine/core';

// Cloudhouse brand palette (per cloudhouse-branding skill).
// Primary: navy #0D2839 (80%+ surface), Accent: green #3BD481 (sparing accent),
// Spotlight: orange #FF751F (one element max), Secondary: light blue #00B5F8.
export const cloudhouseTheme = createTheme({
  primaryColor: 'cloudhouseGreen',
  primaryShade: 5,
  colors: {
    cloudhouseGreen: [
      '#E6FAF0', '#C2F4DA', '#9DEEC4', '#79E8AD', '#54E297',
      '#3BD481', '#168B51', '#208E54', '#13683E', '#054329',
    ],
    cloudhouseNavy: [
      '#E6ECF0', '#C0CFD9', '#99B1C2', '#7394AB', '#4D7793',
      '#26597C', '#0D2839', '#0A2030', '#071826', '#03101C',
    ],
    cloudhouseBlue: [
      '#E6F7FE', '#BFEAFC', '#99DDFA', '#73D0F9', '#4CC3F7',
      '#00B5F8', '#0095CD', '#0075A1', '#005576', '#00354A',
    ],
  },
  fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontFamilyMonospace: 'Menlo, "Courier New", monospace',
  headings: {
    fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontWeight: '700',
    sizes: {
      h1: { fontSize: rem(40), lineHeight: '1.15', fontWeight: '700' },
      h2: { fontSize: rem(28), lineHeight: '1.2', fontWeight: '700' },
      h3: { fontSize: rem(20), lineHeight: '1.3', fontWeight: '700' },
      h4: { fontSize: rem(16), lineHeight: '1.35', fontWeight: '600' },
    },
  },
  defaultRadius: 'md',
  shadows: {
    md: '0 6px 16px rgba(3, 16, 28, 0.35)',
    lg: '0 12px 28px rgba(3, 16, 28, 0.45)',
  },
});

// Shared brand tokens for inline styling. Exported so components can stay
// consistent without each one re-deriving the same hexes.
export const tokens = {
  navy: '#0D2839',
  navyDeep: '#071826',
  navyDeeper: '#03101C',
  navyBorder: '#173446',
  navyBorderSoft: 'rgba(255, 255, 255, 0.06)',
  green: '#3BD481',
  greenDeep: '#168B51',
  greenSoft: 'rgba(59, 212, 129, 0.12)',
  blue: '#00B5F8',
  blueSoft: 'rgba(0, 181, 248, 0.12)',
  orange: '#FF751F',
  white: '#FFFFFF',
  textMuted: '#A8C0D2',
  textSubtle: '#7B97AB',
  textFaint: '#5C7A92',
} as const;
